import { useContext, useEffect } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import "./App.css";
import { AppContext } from "./context/AppProvider";
import Admin from "./layouts/Admin";
import { Login } from "./layouts/Login";
function App() {
    const { isLogin, setUser } = useContext(AppContext);
    let history = useHistory();
    const location = useLocation();

    const clearAuthStorage = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("vhgp-token");
    };

    const isAdminRole = (roleId) => String(roleId) === "1";

    useEffect(() => {
        const userString = localStorage.getItem("user");
        const token = localStorage.getItem("vhgp-token");
        const isInLoginPage = location.pathname === "/login";

        if (!userString || !token) {
            clearAuthStorage();
            setUser({});
            if (!isInLoginPage) {
                history.push("/login");
            }
            return;
        }

        try {
            const userParsed = JSON.parse(userString);
            if (!isAdminRole(userParsed?.roleId)) {
                clearAuthStorage();
                setUser({});
                if (!isInLoginPage) {
                    history.push("/login");
                }
                return;
            }

            setUser(userParsed);
            if (isInLoginPage) {
                history.push("/");
            }
        } catch (error) {
            clearAuthStorage();
            setUser({});
            if (!isInLoginPage) {
                history.push("/login");
            }
        }
    }, [history, isLogin, location.pathname, setUser]);

    return (
        <Switch>
            <Route path="/login" render={(props) => <Login />} />
            <Route path="/" render={(props) => <Admin {...props} />} />
            <Redirect from="*" to="/" />
        </Switch>
    );
}

export default App;
